import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";
import { useEffect, useRef, useState } from "react";

const Dropdown = ({
  data,
  onChange,
  value,
  open = false,
  setOpen,
  isMulti = false,
  allowSearch = false,
}: {
  data: string[] | number[];
  onChange?: (value: string) => void;
  value?: string;
  open?: boolean;
  setOpen?: (open: boolean) => void;
  isMulti?: boolean;
  allowSearch?: boolean;
}) => {
  const valueList = value?.split(", ").filter((item) => item !== "");
  const [search, setSearch] = useState<string>("");

  const isSelected = (item: string) => {
    if (isMulti) {
      return valueList?.includes(item);
    } else {
      return value === item;
    }
  };
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (event: any) => {
      if (open && ref.current && !ref.current.contains(event.target)) {
        setOpen?.(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, [open]);

  return (
    <Container
      ref={ref}
      style={{
        display: open ? "flex" : "none",
      }}
    >
      {allowSearch && (
        <InputContainer>
          <UI.Input
            size="small"
            onChange={(value) => {
              if (data.length > 0) setSearch(value);
              else onChange?.(value);
            }}
          />
        </InputContainer>
      )}
      <DataList>
        {data
          .filter((item) => item.toString().includes(search))
          .map((item, index) => (
            <ItemContainer
              key={index}
              onClick={() => {
                if (isMulti) {
                  if (valueList?.includes(item.toString())) {
                    onChange?.(valueList?.filter((value) => value !== item.toString()).join(", "));
                  } else {
                    onChange?.([...(valueList ?? []), item.toString()].join(", "));
                  }
                } else {
                  onChange?.(item.toString());
                }
              }}
              style={{
                backgroundColor: isSelected(item.toString()) ? "var(--alias-color-background-normal-selected)" : "",
              }}
            >
              <UI.Typography
                type="label01"
                fontStyle={isSelected(item.toString()) ? "bold" : "regular"}
                color="var(--alias-color-label-normal)"
                style={{
                  width: "100%",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {item}
              </UI.Typography>
            </ItemContainer>
          ))}
      </DataList>
    </Container>
  );
};

export default Dropdown;

const Container = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  width: 160px;
  height: 160px;
  padding-right: 4px;
  justify-content: flex-end;
  align-items: flex-start;

  border-radius: 0px 0px 8px 8px;
  background: var(--alias-color-background-normal-normal);
  box-shadow: var(--alias-style-shadow-strong);
`;

const DataList = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  overflow-y: scroll;
  height: 100%;

  ::-webkit-scrollbar {
    background-color: white;
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: var(--component-color-fill-normal);
    width: 4px;
    border-radius: 6px;
  }
`;

const ItemContainer = styled.div`
  display: flex;
  padding: 8px 12px;
  align-items: center;
  align-self: stretch;

  &:hover {
    background-color: var(--component-color-fill-normal);
  }
`;

const InputContainer = styled.div`
  display: flex;
  padding: 6px;
  flex-direction: column;
  /* justify-content: center; */
  height: min-content;
  align-items: flex-start;
  align-self: stretch;
`;
